import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { ButtonTypeTokens, InputStateToken, } from '@voltmoney/schema';
import SharedPropsService from '../../../SharedPropsService';
import { AssetRepositoryMap, AssetRepositoryType, getAppHeader, getPrimaryAssetRepositoryForPledge, } from '../../../configs/config';
import { api } from '../../../configs/api';
import _ from 'lodash';
import { AnalyticsEventTracker, } from '../../../configs/constants';
import { fetchPledgeLimitRepo } from '../unlock_limit/repo';
import { nextStepCredStepper } from '../../../configs/utils';
import { ACTIONS } from "../../mfFetch/otp_CAS/types";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getPledgeDetailsFromNetwork } from './utils';
let counter = 0;
let errorCounter = 0;
let currentStep = "";
export const sendOtpForPledgeConfirm = async (action, _datastore, { instrumentTrack, analytics, network, navigate, setDatastore }) => {
    await setDatastore(ROUTE.ALERT_PAGE, 'alert', {
        loading: true,
    });
    console.warn("ASSET SAGAR", action.payload);
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: '',
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    AssetRepositoryMap.get(AssetRepositoryType.CAMS).LIST = [];
    AssetRepositoryMap.get(AssetRepositoryType.KARVY).LIST = [];
    console.warn("ASSET REPO MAP TYPE ", AssetRepositoryMap);
    let primaryType = await getPrimaryAssetRepositoryForPledge();
    let toBePledgedAssets = await SharedPropsService.getToBePledgedAssets();
    console.warn("ASSET REPO TO BE PLEDGED TYPE ", toBePledgedAssets);
    toBePledgedAssets.forEach(item => {
        if (item.pledgedUnits > 0) {
            AssetRepositoryMap.get(AssetRepositoryType[item.assetRepository]).LIST.push({
                ...item,
                is_pledged: true,
            });
        }
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    console.log("Asset repo map reveived $$$$", AssetRepositoryMap);
    /**** check if user has empty cams portfolio then switch asset repository type ****/
    if (AssetRepositoryMap.get(AssetRepositoryType.CAMS).LIST.length === 0 ||
        AssetRepositoryMap.get(AssetRepositoryType.CAMS).IS_PLEDGED) {
        primaryType = AssetRepositoryType.KARVY;
    }
    if (AssetRepositoryMap.get(AssetRepositoryType.KARVY).LIST.length === 0) {
        primaryType = AssetRepositoryType.CAMS;
    }
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: 'Confirm & get OTP',
        type: ButtonTypeTokens.LargeFilled,
        loading: false,
    });
    const body = {
        applicationId: applicationId,
        assetRepository: primaryType,
        portfolioItemList: action.payload.value.pledgedPortfolio,
    };
    /** actual api call with body */
    const response = await network.post(api.pledgeCreate, body, {
        headers: await getAppHeader(),
    });
    const data = _.get(response, 'data.stepResponseObject');
    if (_.get(response, 'data.status') === 'SUCCESS') {
        analytics(AnalyticsEventTracker.borrower_mf_pledge_init['Event Name'], {
            ...AnalyticsEventTracker.borrower_mf_pledge_init,
        });
        console.log("Action received is", action);
    }
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: 'Confirm & get OTP',
        type: ButtonTypeTokens.LargeFilled,
        loading: false,
    });
};
export const authCAS = async (action, _datastore, { navigate, setDatastore, network, analytics, showPopup, hidePopup, goBack, navigateWithClear, ...props }) => {
    console.warn("*** authCAS action trigerred *** ");
    let assetRepositoryType = action?.payload?.assetRepositoryType ? action?.payload?.assetRepositoryType : AssetRepositoryType.CAMS;
    await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
        error: false,
        errorCounter: errorCounter
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    if (action.payload.value.length !==
        AssetRepositoryMap.get(assetRepositoryType).OTP_LENGTH) {
        return;
    }
    await setDatastore(action.routeId, 'input', {
        state: InputStateToken.LOADING,
    });
    const response = await network.post(api.authCAS, {
        applicationId: applicationId,
        otp: action.payload.value,
        assetRepository: assetRepositoryType,
    }, { headers: await getAppHeader() }, async () => {
    }, {
        disableDefault: true
    });
    if (response.status === 200) {
        const updatedPledgeData = await getPledgeDetailsFromNetwork({ network });
        await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
            showCamsFetchSuccess: true,
            counter: counter + 1,
            pledgingOrder: updatedPledgeData?.pendingOTPMap
        });
    }
    else if (response?.response?.status === 500) {
        if (Platform.OS === "ios") {
            await goBack();
        }
        await showPopup({
            type: 'FAILED',
            title: 'Sorry something went wrong  ',
            subTitle: `${response?.response?.data?.message}`,
            ctaLabel: 'Okay',
            primary: true,
            ctaAction: {
                routeId: ROUTE.ASSET_PLEDGE_V2,
                type: ACTION.BACK_BUTTON,
                payload: {}
            }
        });
    }
    else {
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_OTP_INVALID") {
            await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
                error: true,
                userName: _.get(response, 'response.data.message'),
                errorCounter: errorCounter + 1
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_PORTFOLIO_NOT_FOUND") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failed!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                    type: ACTION.BACK_BUTTON,
                    payload: {}
                }
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failed!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                    type: ACTION.BACK_BUTTON,
                    payload: {}
                }
            });
        }
    }
};
export const fetchMyPortfolio = async (action, _datastore, { network, navigateWithClear, setDatastore, navigate, goBack, analytics, instrumentTrack, ...props }) => {
    console.log("*** fetchMyPortfolio triggered ***", action);
    const assetRepository = action?.payload?.assetRepository ? action?.payload?.assetRepository : AssetRepositoryType.CAMS;
    await setDatastore(action.routeId, "fetchCTA", {
        label: "",
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const user = await SharedPropsService.getUser();
    await analytics("eligibility_sucess", { "event": "eligibility_sucess" });
    const userCredential = await network.post(api.getCredentialsForAssetFetch, {
        applicationId: applicationId,
        assetRepository: assetRepository
    }, {
        headers: await getAppHeader(),
    });
    const response = await network.post(api.fetchInitV2, {
        applicationId: applicationId,
        emailId: userCredential?.data?.emailId,
        phoneNumber: userCredential?.data?.phoneNumber,
        panNumber: userCredential?.data?.panNumber,
        assetRepository: assetRepository,
    }, {
        headers: await getAppHeader(),
        handleFromMF: false
    });
    if (response?.status === 200) {
        user.linkedApplications[0].currentStepId = _.get(response, "response.data.updatedApplicationObj.currentStepId", response.data.updatedApplicationObj.currentStepId);
        await SharedPropsService.setUser(user);
        await setDatastore(ROUTE.ASSET_PLEDGE_V2, "assetPledge", {
            identifier: response.data.stepResponseObject.identifier,
            otpChannel: response.data.stepResponseObject.otpChannel,
            noOfDigits: response.data.stepResponseObject.noOfDigits,
            showCamsFetchSuccess: false,
            currentAssetRepository: assetRepository,
            counter: Math.random()
        });
    }
    else {
        await setDatastore(ROUTE.ASSET_PLEDGE_V2, "assetPledge", {
            isError: true
        });
    }
};
export const onLoad = async (action, _datastore, { instrumentTrack, navigate, showPopup }) => {
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    const authCAS = await SharedPropsService.getAuthCASResponse();
    const pledgeLimitResponse = authCAS
        ? { data: authCAS.stepResponseObject.availableCAS }
        : await fetchPledgeLimitRepo().then(response => ({
            data: response.stepResponseObject.tobePledgedPortfolio,
        }));
};
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const triggerOtpForPledge = async (action, _datastore, { setDatastore, network }) => {
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const body = {
        applicationId: applicationId,
        otpType: action.payload.value
    };
    const response = await network.post(api.pledgeInitV2, body, {
        headers: await getAppHeader(),
    });
    if (response?.status === 200) {
        await setDatastore(ROUTE.ASSET_PLEDGE_V2, "assetPledge", {
            noOfDigits: response.data.stepResponseObject.noOfDigits,
            identifier: response.data.stepResponseObject.identifier,
            otpChannel: response.data.stepResponseObject.otpChannel,
            counter: Math.random()
        });
    }
    else {
        await setDatastore(ROUTE.ASSET_PLEDGE_V2, "assetPledge", {
            isError: true
        });
    }
};
export const verifyPledgeOtp = async (action, _datastore, { goBack, network, setDatastore, showPopup }) => {
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const user = await SharedPropsService.getUser();
    await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
        error: false,
        errorCounter: errorCounter
    });
    const body = {
        applicationId: applicationId,
        otpType: action.payload.value,
        otp: action.payload.otp
    };
    const response = await network.post(api.assetPledgeVerify, body, {
        headers: await getAppHeader(),
        handleFromMF: true
    });
    if (response.status === 200) {
        currentStep = response.data.updatedApplicationObj.currentStepId;
        user.linkedApplications[0] = response.data.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        if (action.payload.value === "CAMS_PLEDGE") {
            await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
                showCamsPledgeSuccesss: true,
                CamsCounter: counter + 1,
                successAmount: response.data.stepResponseObject.approvedCreditLimit,
            });
        }
        else {
            await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
                showKarvyPledgeSuccess: true,
                kFinCounter: counter + 1,
                successAmount: response.data.stepResponseObject.approvedCreditLimit
            });
        }
    }
    else if (response?.response?.status === 500) {
        if (Platform.OS === "ios") {
            await goBack();
        }
        await showPopup({
            type: 'FAILED',
            title: 'Sorry something went wrong  ',
            subTitle: `${response?.response?.data?.message}`,
            ctaLabel: 'Okay',
            primary: true,
            ctaAction: {
                routeId: ROUTE.ASSET_PLEDGE_V2,
                type: ACTION.BACK_BUTTON,
                payload: {}
            }
        });
    }
    else {
        if (_.get(response, 'response.data.voltErrorCode', false)) {
            await setDatastore(ROUTE.ASSET_PLEDGE_V2, 'assetPledge', {
                error: true,
                userName: _.get(response, 'response.data.message'),
                errorCounter: errorCounter + 1,
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "BAD_REQUEST_INVALID_INPUT") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failedssss!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                    type: ACTION.BACK_BUTTON,
                    payload: {}
                }
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failed!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                    type: ACTIONS.GO_BACK,
                    payload: {}
                }
            });
        }
    }
};
export const goToKfs = async (action, _datastore, { navigate, network, instrumentTrack, removeWidgets, navigateWithClear }) => {
    const routeObj = await nextStepCredStepper();
    if (routeObj.routeId === "CREDIT_APPROVAL" || routeObj.routeId === "LOAN_AGREEMENT" || routeObj.routeId === "REVIEW_KFS" || routeObj.routeId === "LOAN_AGREEMENT_POLLING") {
        await navigateWithClear(ROUTE.BAJAJ_AGREEMENT_STEPPER);
    }
    else {
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goToStateSelectionPage = async (action, _datastore, { navigate }) => {
    const stateDutyStamp = action.payload.stateDutyStamp;
    await navigate(ROUTE.STATE_SELECTION, { stateDutyStamp: stateDutyStamp });
};
export const goToFaq = async (action, _datastore, { instrumentTrack, navigate }) => {
    instrumentTrack("FAQ_BUTTON_CLICKED", { "page": "confirm_pledge" });
    await navigate(ROUTE.FAQ);
};
